import BaseSettings from "./base-settings";
import {registerSettings} from "./register";

class AdvancedSettings extends BaseSettings {

}

registerSettings('ppcp_advanced', AdvancedSettings);